import { useState } from "react";
import { ArrowUp, ArrowDown, ArrowUpDown } from "lucide-react";

/**
 * Header kolom tabel yang bisa diklik untuk mengurutkan — SATU sumber dipakai
 * lintas modul (mula-mula ditulis khusus Marketing di `pages/marketing/_shared.jsx`,
 * diangkat ke sini brief owner 19 Agu poin 3 supaya Inventory/halaman lain tidak
 * menyalin ulang, lihat "Duplikasi helper melahirkan penyimpangan" di CLAUDE.md).
 *
 * Sengaja CLIENT-SIDE (mengurutkan array yang SUDAH ada di memori) — cocok
 * untuk daftar yang sudah disaring/dibatasi backend ke ukuran wajar untuk satu
 * layar (ratusan baris, bukan puluhan ribu). Kalau suatu halaman butuh sort
 * atas dataset yang jauh lebih besar dari itu, urutkan di query Mongo, jangan
 * paksakan pola ini.
 */
export function useSortState(defaultKey = null, defaultDir = "desc") {
  const [sortKey, setSortKey] = useState(defaultKey);
  const [sortDir, setSortDir] = useState(defaultDir);
  const toggle = (key) => {
    if (key === sortKey) setSortDir((d) => (d === "asc" ? "desc" : "asc"));
    else { setSortKey(key); setSortDir("asc"); }
  };
  return { sortKey, sortDir, toggle };
}

/** `getters[sortKey]` opsional — kalau tidak disebut, dibaca langsung dari `row[sortKey]`. */
export function sortRows(rows, sortKey, sortDir, getters = {}) {
  if (!sortKey) return rows;
  const get = getters[sortKey] || ((r) => r[sortKey]);
  const sorted = [...rows].sort((a, b) => {
    let va = get(a); let vb = get(b);
    if (va == null) va = "";
    if (vb == null) vb = "";
    if (typeof va === "string") va = va.toLowerCase();
    if (typeof vb === "string") vb = vb.toLowerCase();
    if (va < vb) return -1;
    if (va > vb) return 1;
    return 0;
  });
  return sortDir === "desc" ? sorted.reverse() : sorted;
}

export function SortTh({ label, sortKeyName, sortKey, sortDir, onSort, align = "left", className = "", testid }) {
  const aktif = sortKey === sortKeyName;
  const Icon = !aktif ? ArrowUpDown : sortDir === "asc" ? ArrowUp : ArrowDown;
  return (
    <th className={`px-3 py-2.5 font-semibold ${align === "right" ? "text-right" : "text-left"} ${className}`}>
      <button type="button" onClick={() => onSort(sortKeyName)} data-testid={testid}
              className={`inline-flex items-center gap-1 hover:text-emerald-700 ${aktif ? "text-emerald-700" : ""}`}>
        {label} <Icon className="w-3 h-3" />
      </button>
    </th>
  );
}
